// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/article-page-video-carousel-item/article-page-video-carousel-item.component.scss
// module id = 394
// module chunks = 0